var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { BFormInput } from "bootstrap-vue";
import { ref } from "vue";
import { useRouter } from "vue-router/composables";
import { createWorkflow } from "@/components/Workflow/workflows.services";
import { Toast } from "@/composables/toast";
import AsyncButton from "@/components/Common/AsyncButton.vue";
import Heading from "@/components/Common/Heading.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowCreate',
    props: {
        showHeading: { type: Boolean }
    },
    setup(__props) {
        library.add(faCheck);
        const router = useRouter();
        const workflowAnnotation = ref("");
        const workflowName = ref("Unnamed workflow");
        const workflowNameInput = ref(null);
        function onCreate() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const data = yield createWorkflow(workflowName.value, workflowAnnotation.value);
                    Toast.success(data.message);
                    router.push(`/workflows/edit?id=${data.id}`);
                }
                catch (e) {
                    const error = e;
                    Toast.error((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data.err_msg) !== null && _b !== void 0 ? _b : "Failed to create workflow");
                }
            });
        }
        return { __sfc: true, router, workflowAnnotation, workflowName, workflowNameInput, onCreate, faCheck, BFormInput, AsyncButton, Heading };
    }
});
